import { Colors } from "kadow-jetpack-model";
import { tt } from "../utils/i18n/i18n";

export const COLOR_LABELS: {
  [key: string]: {
    [s in keyof Colors]: string;
  };
} = {
  jpPOSA: {
    primary: tt("color_secondary"),
    background: tt("color_background"),
    accent: tt("color_titles"),
    subtitle: tt("color_subtitle")
  },
  jpMobilePreview: {
    primary: tt("color_secondary"),
    background: tt("color_background"),
    accent: tt("color_buttons"),
    titles: tt("color_titles")
  }
};
